function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 45,
  r: 45,
  fill: "#F5F5F5",
  fillOpacity: 0.3
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.3115 65.9153C21.6019 65.9153 20.0146 65.0393 19.1161 63.6004C18.2176 62.1615 18.1363 60.3648 18.9008 58.8527L40.2721 19.8106C41.1064 18.157 42.8153 17.1127 44.6828 17.1127C46.5503 17.1127 48.2592 18.157 49.0934 19.8106L70.4647 58.8528C71.2292 60.3656 71.1478 62.1624 70.2486 63.6006C69.3509 65.0395 67.763 65.9155 66.0541 65.9155H23.3115V65.9153Z",
  fill: "#D32F2F"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M44.9996 17.1127C43.1546 17.1127 41.4663 18.157 40.6421 19.8106L19.5283 58.8528C18.773 60.3656 18.8534 62.1624 19.741 63.6006C20.6285 65.0395 22.1966 65.9155 23.8858 65.9155H44.9996V17.1127Z",
  fill: "#EF5350"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M43.3863 30.4225C42.3695 30.4225 41.7516 31.2769 41.8393 32.3552L42.1975 47.3918C42.2861 48.3802 44.0937 49.01 44.9788 49.01C45.8623 49.01 47.7941 48.3802 47.8819 47.3918L48.1612 32.3552C48.2496 31.2769 47.5862 30.4225 46.5696 30.4225H43.3863ZM48.1181 55.3927C48.1181 53.6401 46.7911 52.291 44.9795 52.291C43.2108 52.291 41.8393 53.6401 41.8402 55.3927V55.8418C41.8402 57.5954 43.2108 58.9436 44.9795 58.9436C46.7911 58.9436 48.1181 57.5954 48.1181 55.8418V55.3927Z",
  fill: "white"
});

function SvgCaution(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.3fe0e336.svg";
export { ForwardRef as ReactComponent };